// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portofolio-works {
    display: flex;
    margin: auto;
    justify-content: center;
}

.portofolio-image {
    flex: 1 1;
    height: 400px;

    & img {
        width: 100%;
    }
}

.portofolio-description {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.portofolio-work-title {
    font-size: 28px;
    font-weight: 400;
    padding-bottom: 10px;
    font-family: "League Spartan", serif;
    text-align: center;
    margin-top: 10px;
}

.portofolio-work-description {
    padding: 1rem 3rem;
    margin-bottom: 1rem;
    color: #545454;
    text-align: justify;
}


@media (min-width: 991px){
    .portofolio-work-title {
        margin-top: -20px;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/portofolio/portofolio.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,aAAa;;IAEb;QACI,WAAW;IACf;AACJ;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;;AAGA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ","sourcesContent":[".portofolio-works {\n    display: flex;\n    margin: auto;\n    justify-content: center;\n}\n\n.portofolio-image {\n    flex: 1;\n    height: 400px;\n\n    & img {\n        width: 100%;\n    }\n}\n\n.portofolio-description {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.portofolio-work-title {\n    font-size: 28px;\n    font-weight: 400;\n    padding-bottom: 10px;\n    font-family: \"League Spartan\", serif;\n    text-align: center;\n    margin-top: 10px;\n}\n\n.portofolio-work-description {\n    padding: 1rem 3rem;\n    margin-bottom: 1rem;\n    color: #545454;\n    text-align: justify;\n}\n\n\n@media (min-width: 991px){\n    .portofolio-work-title {\n        margin-top: -20px;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
